import { Routes } from '@angular/router';
import { roleGuard } from './guards/role-guard.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'sales',
    pathMatch: 'full',
  },
  {
    path: 'measurement-sets/:measurementSetId',
    loadComponent: () =>
      import('./pages/measurement-set/measurement-set.page').then(
        (c) => c.MeasurementSetPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'measurement-types/:measurementTypeId',
    loadComponent: () =>
      import('./pages/measurement-type/measurement-type.page').then(
        (c) => c.MeasurementTypePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'sale-photos/:salePhotoId',
    loadComponent: () =>
      import('./pages/sale-photo/sale-photo.page').then((c) => c.SalePhotoPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'sales/:saleId',
    loadComponent: () =>
      import('./pages/sale/sale.page').then((c) => c.SalePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((c) => c.LoginPage),
    pathMatch: 'full',
  },
  {
    path: 'manage-users',
    loadComponent: () =>
      import('./pages/manage-users/manage-users.page').then(
        (c) => c.ManageUsersPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'measurement-types',
    loadComponent: () =>
      import('./pages/measurement-types/measurement-types.page').then(
        (c) => c.MeasurementTypesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('./pages/not-authorized/not-authorized.page').then(
        (c) => c.NotAuthorizedPage,
      ),
    pathMatch: 'full',
  },
  {
    path: 'personal-access-tokens',
    loadComponent: () =>
      import('./pages/personal-access-tokens/personal-access-tokens.page').then(
        (c) => c.PersonalAccessTokensPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'sales',
    loadComponent: () =>
      import('./pages/sales/sales.page').then((c) => c.SalesPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'switch-user',
    loadComponent: () =>
      import('./pages/switch-user/switch-user.page').then(
        (c) => c.SwitchUserPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
];
